export default "__VITE_ASSET__ffd5a2f5__"